import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import {
    ICreateLoyaltyLevelPayload,
    IListLoyaltyLevelsResponse,
    ILoyaltyLevel,
    IUpdateLoyaltyLevelPayload,
} from "./types"

const appendNumber = (formData: FormData, key: string, value: number) => {
    formData.append(key, String(value))
}

export const listLoyaltyLevels = (): Promise<AxiosResponse<IListLoyaltyLevelsResponse>> => {
    return apiInstance.handler.get<IListLoyaltyLevelsResponse>("/loyalty-levels")
}

export const createLoyaltyLevel = (data: ICreateLoyaltyLevelPayload): Promise<AxiosResponse<ILoyaltyLevel>> => {
    const formData = new FormData()
    appendNumber(formData, "level", data.level)
    formData.append("name", data.name)
    appendNumber(formData, "cashback_percent", data.cashback_percent)
    appendNumber(formData, "paid_amount_rub", data.paid_amount_rub)
    formData.append("icon", data.icon)

    return apiInstance.handler.post<ILoyaltyLevel>("/loyalty-levels", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    })
}

export const updateLoyaltyLevel = (
    level: number,
    data: IUpdateLoyaltyLevelPayload
): Promise<AxiosResponse<ILoyaltyLevel>> => {
    const formData = new FormData()
    formData.append("name", data.name)
    appendNumber(formData, "cashback_percent", data.cashback_percent)
    appendNumber(formData, "paid_amount_rub", data.paid_amount_rub)

    if (typeof data.icon !== "undefined") {
        formData.append("icon", data.icon)
    }

    return apiInstance.handler.put<ILoyaltyLevel>(`/loyalty-levels/${level}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    })
}

export const deleteLoyaltyLevel = (level: number): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.delete<void>(`/loyalty-levels/${level}`)
}
